module.exports = __webpack_public_path__ + "static/img/bililogo.30f271d.png";


//////////////////
// WEBPACK FOOTER
// ./static/bililogo.png
// module id = j2yb
// module chunks = 0